import { BarComposition, InvestmentProjection } from './types'

type CalcBarCompositionInput = {
  currentProjection: InvestmentProjection
  graphHeight: number
  investmentAmount: number
  maxInvestmentAmount: number
  maxProjection: InvestmentProjection
}

export const calcBarComposition = ({
  graphHeight,
  currentProjection,
  maxProjection,
  maxInvestmentAmount,
  investmentAmount,
}: CalcBarCompositionInput): BarComposition => {
  const barHeight = maxProjection.projectionTotal
    ? graphHeight *
      (0.8 + (0.2 * investmentAmount) / maxInvestmentAmount) *
      (currentProjection.projectionTotal / maxProjection.projectionTotal)
    : (0 as number)

  const investedPercentage = currentProjection.projectionTotal
    ? (currentProjection.investedTotal / currentProjection.projectionTotal) *
      1.1
    : 1
  return {
    investedPercentage,
    barHeight,
  }
}
